module.exports = __webpack_public_path__ + "assets/img/about-us.31c1a215.webp";